import React from "react";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as ACTIONS from '../../../store/actions/actions';

import Input from '../Input';

function Common(props) {
    return (
    <>
        <Input
          label='Imię'
          className='form-input'
          type='text'
          name='username'
          placeholder='Wpisz swoje Imię'
          value={props.user_name}
          handleChange={(e) => props.action_creator_name(e.target.value)}
        />
        <div className="input__error-box">
          <p className="input__error">{props.errors.username}</p>
        </div>
        <Input
          label='Nazwisko'
          className='form-input'
          type='text'
          name='surname'
          placeholder='Wpisz swoje Nazwisko'
          value={props.user_surname}
          handleChange={(e) => props.action_creator_surname(e.target.value)}
        />
        <div className="input__error-box">
          <p className="input__error">{props.errors.surname}</p>
        </div>
        <Input
          label='Stanowisko'
          className='form-input'
          type='text'
          name='position'
          placeholder='Wpisz swoje Stanowisko'
          value={props.user_position}
          handleChange={(e) => props.action_creator_position(e.target.value)}
        />
        <div className="input__error-box">
          <p className="input__error">{props.errors.position}</p>
        </div>
        <Input
          label='Email'
          className='form-input'
          type='email'
          name='email'
          placeholder='Wpisz swój email'
          value={props.user_email}
          handleChange={(e) => props.action_creator_email(e.target.value)}
        />
        <div className="input__error-box">
          <p className="input__error">{props.errors.email}</p>
        </div>
        <Input
          label='Telefon'
          className='form-input'
          type='text'
          name='phone'
          placeholder='Wpisz swój nr tel. bez spacji'
          value={props.user_phone}
          handleChange={(e) => props.action_creator_phone(e.target.value)}
        />
        <div className="input__error-box">
          <p className="input__error">{props.errors.phone}</p>
        </div>
    </>
    );
}

Common.propTypes = {
  user_name: PropTypes.string,
  user_surname: PropTypes.string,
  user_position: PropTypes.string,
  user_email: PropTypes.string,
  user_phone: PropTypes.string,
}

function mapStateToProps(state) {
  return {
    user_name: state.user_reducer.user_name,
    user_surname: state.user_reducer.user_surname,
    user_position: state.user_reducer.user_position,
    user_email: state.user_reducer.user_email,
    user_phone: state.user_reducer.user_phone,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    action_creator_name: (text) => dispatch(ACTIONS.user_name(text)),
    action_creator_surname: (text) => dispatch(ACTIONS.user_surname(text)),
    action_creator_position: (text) => dispatch(ACTIONS.user_position(text)),
    action_creator_email: (text) => dispatch(ACTIONS.user_email(text)),
    action_creator_phone: (text) => dispatch(ACTIONS.user_phone(text)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Common);